import { MapUtils } from '../../../../utility/map-utils.js';
import { cloneData, isSameData } from '../../../dto/data-model-utils.js';
import {
  SerializedData, SerializationContext, DataModelBuilder,
  DataModel,
} from '../../../dto/data-model.js';
import { GenericOrder } from '../../orders/generic-order.js';
import { AuditLogEntryType } from '../audit-log-entry-type.js';
import { AuditLogEntry } from '../audit-log-entry.js';

export class GenericOrderCompletedEntry extends AuditLogEntry {
  static readonly TYPE_ID: string = 'a2f753fd071844d299827cf45ae963b8';

  private constructor(
    public readonly before: GenericOrder,
    public readonly after: GenericOrder,
  ) {
    super();
  }

  get $typeId(): string {
    return GenericOrderCompletedEntry.TYPE_ID;
  }

  get type(): AuditLogEntryType {
    return AuditLogEntryType.GenericOrderCompleted;
  }

  generateQueryData(): SerializedData {
    return {
      businessRef: this.after.businessRef.encode(),
      orderId: this.after.uniqueId,
      customerId: this.after.creatorId,
      isGuestOrder: this.after.isGuestOrder,
    };
  }

  static create(args: {
    before: GenericOrder,
    after: GenericOrder,
  }): GenericOrderCompletedEntry {
    return new GenericOrderCompletedEntry(
        args.before,
        args.after,
    );
  }

  static fromMap(context: SerializationContext, map: SerializedData): GenericOrderCompletedEntry {
    return this.create({
      before: context.fromData<GenericOrder>(MapUtils.getRecord(map, 'before')),
      after: context.fromData<GenericOrder>(MapUtils.getRecord(map, 'after')),
    });
  }

  toMap(context: SerializationContext): SerializedData {
    return {
      before: context.toData(this.before),
      after: context.toData(this.after),
    };
  }

  clone(): this {
    return GenericOrderCompletedEntry.create({
      before: cloneData(this.before),
      after: cloneData(this.after),
    }) as this;
  }

  isSame(other: this): boolean {
    if(other === this) {
      return true;
    }

    return isSameData(other.before, this.before) &&
           isSameData(other.after, this.after);
  }

  static verifyType(dm: DataModel): boolean {
    return dm instanceof GenericOrderCompletedEntry;
  }

  static assertType(dm: DataModel): dm is GenericOrderCompletedEntry {
    return dm instanceof GenericOrderCompletedEntry;
  }
}

export class GenericOrderCompletedEntryBuilder extends DataModelBuilder<GenericOrderCompletedEntry> {
  build(context: SerializationContext, map: SerializedData): GenericOrderCompletedEntry {
    return GenericOrderCompletedEntry.fromMap(context, map);
  }
}
